import "./Upload.scss";

import VideoForm from "../../components/VideoForm/VideoForm";

function Upload() {
  return (
    <section className="upload">
      <div className="upload__wrapper">
        <h1 className="upload__heading">Upload Video</h1>
        <VideoForm />
      </div>
    </section>
  );
}

export default Upload;
